import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import NormalTabs from '../../../ui/tabs/NormalTabs';
import AINormalInput from '../../../ui/inputs/AINormalInput';
import AISelectInput from '../../../ui/inputs/AISelectInput';
import MainSquareButton from '../../../ui/buttons/MainSquareButton';
import request_mcp_api_call from '../../../lib/api/mcp/request_mcp_api_call';
import '../../../styles/pages/MCP/requestMCP.scss';
import LoadingSpinner from '../../../ui/loadingSpinner/LoadingSpinner';
import NoData from '../../../ui/noData/NoData';
import { plusSignSVG } from '../../../lib/allCustomSVGs';

type Props = {
  toggleRequestMCPPopupModal: () => void;
  scheduledMCPs: any[];
  loading: string;
};

const RequestMCP = ({
  toggleRequestMCPPopupModal,
  scheduledMCPs,
  loading,
}: Props) => {
  const { t } = useTranslation();
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const requestMCPPriorityLevelsArr = [
    { OptionValue: 'Low', OptionName: t('Low') },
    { OptionValue: 'Medium', OptionName: t('Medium') },
    { OptionValue: 'High', OptionName: t('High') },
  ];

  const [isRequestMCPCallLoading, setIsRequestMCPCallLoading] = useState(false);
  const [requestMCPName, setRequestMCPName] = useState('');
  const [requestMCPDescription, setRequestMCPDescription] = useState('');
  const [requestMCPPriorityLevel, setRequestMCPPriorityLevel] = useState('Low');

  const tabItems = [
    {
      text: t('ScheduleMCPs'),
      count: 0,
      icon: null,
    },
    {
      text: t('RequestNew'),
      count: 0,
      icon: null,
    },
  ].map((item, index) => ({
    ...item,
    isActive: index === activeTabIndex,
  }));

  const requestMCP_APICall = async () => {
    setIsRequestMCPCallLoading(true);
    const res = await request_mcp_api_call(
      requestMCPName,
      requestMCPDescription,
      requestMCPPriorityLevel
    );
    if (res) {
      setIsRequestMCPCallLoading(false);
      toggleRequestMCPPopupModal();
    } else {
      setIsRequestMCPCallLoading(false);
    }
  };

  const renderTabContent = () => {
    if (activeTabIndex === 0) {
      if (loading === 'success') {
        return (
          <div className='requestMCP__schedule'>
            <span className='requestMCP__schedule--title'>
              {t('ScheduleMCPTitle')}
            </span>
            <div className='requestMCP__schedule--content'>
              {scheduledMCPs?.map((item, index) => {
                return (
                  <div
                    key={item?.id}
                    className={`requestMCP__schedule--item requestMCP__schedule--item-${item.status}`}
                  >
                    <div className='requestMCP__schedule--item-img'>
                      <img src={item?.logo} alt={item?.mcp_name} />
                    </div>
                    <div className='requestMCP__schedule--item-content'>
                      <h3 className='requestMCP__schedule--item-content-title'>
                        {item?.mcp_name}
                      </h3>
                      {/* <span className='requestMCP__schedule--item-content-subtitle'>
                        {item.subtitle}
                      </span> */}
                      {/* <div className='requestMCP__schedule--item-content-date'>
                        <span className='requestMCP__schedule--item-content-date-title'>
                          {t('EstimatedRelease')}:
                        </span>
                        <span className='requestMCP__schedule--item-content-date-value'>
                          {item.date}
                        </span>
                      </div> */}
                    </div>
                    {/* <div
                      className={`requestMCP__schedule--item-tag requestMCP__schedule--item-tag-${item.status}`}
                    >
                      <CustomSVGs svg={clockSVG} />
                      <span>{t(item.tag)}</span>
                    </div> */}
                  </div>
                );
              })}
            </div>
          </div>
        );
      } else if (loading === 'pending') {
        return <>{loading === 'pending' && <LoadingSpinner />}</>;
      } else if (loading === 'null') {
        return <NoData title={t('NoScheduledMCPsFound')} />;
      } else {
        return null;
      }
    }

    if (activeTabIndex === 1) {
      return (
        <div className='requestMCP__new'>
          <span className='requestMCP__new--title'>{t('NewMCPTitle')}</span>
          <form
            id='request-mcp-form'
            onSubmit={(e) => {
              e.preventDefault();
              requestMCP_APICall();
            }}
          >
            <div className='requestMCP__new--content'>
              <div className='requestMCP__new--content-inputs'>
                <div className='requestMCP__new--content-input'>
                  <AINormalInput
                    changeListeners={[
                      (event) => {
                        setRequestMCPName(
                          (event.target as HTMLInputElement).value
                        );
                      },
                    ]}
                    id={`request-mcp-name-input`}
                    value={requestMCPName}
                    placeholder={t('MCPName')}
                    required={true}
                    innerPlaceholder={t(`EnterMCPName`)}
                  />
                </div>
                <div className='requestMCP__new--content-input'>
                  <AINormalInput
                    changeListeners={[
                      (event) => {
                        setRequestMCPDescription(
                          (event.target as HTMLInputElement).value
                        );
                      },
                    ]}
                    id={`request-mcp-description-input`}
                    value={requestMCPDescription}
                    placeholder={t('MCPDescription')}
                    required={true}
                    innerPlaceholder={t(`EnterMCPDescription`)}
                  />
                </div>
                <div className='requestMCP__new--content-input'>
                  <AISelectInput
                    defaultValue={requestMCPPriorityLevel}
                    setSelect={setRequestMCPPriorityLevel}
                    selectOptionArr={requestMCPPriorityLevelsArr}
                    placeholder={t('PriorityLevel')}
                    id={'RequestMCP-PriorityLevel-select'}
                  />
                </div>
              </div>

              <div className='requestMCP__new--content-btn'>
                <MainSquareButton
                  value={t('Cancel')}
                  buttonType='white'
                  onClick={toggleRequestMCPPopupModal}
                />
                <MainSquareButton
                  value={t('SubmitRequest')}
                  disabled={
                    requestMCPName === '' || requestMCPDescription === ''
                  }
                  loading={isRequestMCPCallLoading}
                  type='submit'
                  form='request-mcp-form'
                  icon={plusSignSVG}
                />
              </div>
            </div>
          </form>
        </div>
      );
    }
  };

  return (
    <div className='requestMCP'>
      <div className='requestMCP__titles'>
        <h3>{t('RequestMCPMainTitle1')}</h3>
        <span>{t('RequestMCPMainTitle2')}</span>
      </div>
      <div className='requestMCP__tabs'>
        <NormalTabs
          tabItems={tabItems}
          onTabClick={setActiveTabIndex}
          showCountInTab='Active'
        />
        {renderTabContent()}
      </div>
    </div>
  );
};

export default RequestMCP;
